import { render, staticRenderFns } from "./AdminTransitionTemplate.vue?vue&type=template&id=6bbfea98&"
import script from "./AdminTransitionTemplate.vue?vue&type=script&lang=js&"
export * from "./AdminTransitionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AdminTransitionTemplate.vue?vue&type=style&index=0&id=6bbfea98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports